
















































import Reflect from "reflect-metadata";
import { Component, Vue, Watch } from "vue-property-decorator";
import { User } from "@/models/User";

import session from "@/services/SessionService";
import messageService from "@/services/MessageService";
import userService, {
  UserSearch,
  UserPayload,
  PermissionsPayload,
} from "@/services/UserService";

import UserInfo from "@/components/UserInfo.vue";
import UserSecurity from "@/components/UserSecurity.vue";
import UserPermission from "../../components/UserPermission.vue";

type PermissionChangeEventPayload = {
  selectedBudgets: PermissionsPayload[];
  selectedPlants: PermissionsPayload[];
  selectedProjects: PermissionsPayload[];
};

@Component({
  components: {
    UserInfo,
    UserSecurity,
    UserPermission,
  },
})
export default class UserNew extends Vue {
  static SAVE_SUCCESSFUL = 1;
  static SAVE_FAILED_EMAIL = 2;
  static SAVE_FAILED_SERVER = 3;
  static FETCH_FAILED = 4;

  loading: boolean = false;
  sessionUser: User | null;

  /**
   * Class constructor.
   */
  constructor() {
    super();
    this.sessionUser = session.getUser();
    if (this.sessionUser && this.sessionUser.is_admin) {
      this.payload.user.contact = this.sessionUser.contact;
    }
    this.payload.security.password = Math.random().toString(36).slice(2);
  }
  /**
   * Component data
   */
  payload: UserPayload = {
    user: {},
    permissions: [],
    security: {
      auto: true,
      send_email: true,
    },
  };
  valid: boolean = false;

  /**
   * Saves the new user
   */
  saveUser() {
    this.loading = true;
    userService
      .save(this.payload)
      .then((response) => {
        messageService.addMessage({
          id: UserNew.SAVE_SUCCESSFUL,
          type: "success",
          text: "El usuario se ha creado exitosamente.",
          overrides: true,
        });
        this.$router.push("/users");
      })
      .catch((error) => {
        messageService.addMessage({
          id: UserNew.SAVE_FAILED_SERVER,
          type: "error",
          text: "El usuario no se pudo crear correctamente. Intente mas tarde.",
        });
        this.loading = false;
      });
  }
  /**
   * Executes when component is mounted. Sets event listeners .
   */
  mounted() {
    this.$root.$on("update:password", (value: string) => {
      this.payload.security.password = value;
    });

    this.$root.$on(
      "change:permissions",
      (payload: PermissionChangeEventPayload) => {
        this.payload.permissions = payload.selectedProjects.concat(
          payload.selectedBudgets.concat(payload.selectedPlants)
        );
      }
    );

    this.$root.$on("change:user", (payload: Partial<User>) => {
      this.payload.user = Object.assign(this.payload.user, payload);
    });
  }
}
